import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaycard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31.114 22.697",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5,0A2.5,2.5,0,0,0,0,2.5V16.18a2.5,2.5,0,0,0,2.5,2.5H26.067a2.5,2.5,0,0,0,2.5-2.5V2.5a2.5,2.5,0,0,0-2.5-2.5Zm0,.912H26.067A1.573,1.573,0,0,1,27.655,2.5V4.066H.912V2.5A1.573,1.573,0,0,1,2.5.912ZM.912,4.977H27.655V6.74H.912Zm0,2.676H27.655V16.18a1.573,1.573,0,0,1-1.588,1.585H2.5A1.573,1.573,0,0,1,.911,16.18ZM18.066,10.47a2.6,2.6,0,1,0,1.526,4.7,2.6,2.6,0,1,0,0-4.2,2.6,2.6,0,0,0-1.526-.5m0,.912a1.684,1.684,0,0,1,.888.254,2.6,2.6,0,0,0-.174.311l-.018.038a2.6,2.6,0,0,0-.2.677c0,.018-.006.035-.008.053a2.3,2.3,0,0,0,0,.711c0,.018.005.035.008.053a2.6,2.6,0,0,0,.2.677l.018.038a2.644,2.644,0,0,0,.174.31,1.686,1.686,0,1,1-.887-3.121Zm3.055,0a1.688,1.688,0,1,1-1.193,2.88l-.008-.009v0a1.682,1.682,0,0,1,0-2.364h0l.014-.016a1.686,1.686,0,0,1,1.188-.49Z",
		transform: "translate(0.113 4.089) rotate(-8)",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .2
	})
});
export default SvgPaycard;
